module.exports = __webpack_public_path__ + "static/Maesh_PayNow_Prototype-2f4a9347ec2f0c349554da34bff01a60.mp4";